import { styled } from "@linaria/react"
import { lazy } from "react"


import { Loading } from "@/components/Loading.tsx"
import * as textStyles from "@/styles/textStyles.ts"

import type { ReactCodeMirrorProps } from "@uiw/react-codemirror"

const CodeMirrorPrimitive = lazy(() => import("@uiw/react-codemirror"))

export const CodeMirror = (props: ReactCodeMirrorProps) => {
  return (
    <Loading>
      <StyledCodeMirror {...props} />
    </Loading>
  )
}

const StyledCodeMirror = styled(CodeMirrorPrimitive)`
  .cm-editor {
    background: transparent;
  }

  .cm-focused {
    outline: none;
  }

  .cm-scroller {
    ${textStyles.monospaceFont};

    line-height: 150%;
  }
`
